// @flow @jsx h
import { h, Component } from 'preact'

class Provider extends Component<{ children: Array<any> }, {}> {
  getChildContext() {
    const { children, ...props } = this.props
    return { __CTX__: props }
  }
  render() {
    return this.props.children[0]
  }
}

Provider.displayName = 'Provider'

type MapContextToProps = ({}) => Object

function connect(mapContextToProps?: MapContextToProps) {
  return (wrappedComponent: any) => {
    class Connected extends Component<{}, {}> {
      mapContextToProps = (ctx: {}): Object => {
        return mapContextToProps ? mapContextToProps(ctx) : ctx
      }
      render() {
        return h(wrappedComponent, {
          ...this.mapContextToProps(this.context['__CTX__']),
          ...this.props
        })
      }
    }
    Connected.displayName = `connect(${wrappedComponent.displayName || wrappedComponent.name || 'Component'})`
    return Connected
  }
}

export { Provider, connect }



// WEBPACK FOOTER //
// ./src/lib/provider.js